import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
//import "./webpack.config.js";
import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import "./tables.css";   // ← add this line
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// At the bottom of the file, change unregister to register:
serviceWorkerRegistration.register();
// Render app in `#root` element
ReactDOM.render(<App />, document.getElementById("root"));
